export default __webpack_public_path__ + "static/grey-black-bananatex-026ddd51e7ed05df0d802f4ede7935c1.png";